"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Game = void 0;
require("reflect-metadata");
const class_transformer_1 = require("class-transformer");
const nanoid_1 = require("nanoid");
const rxjs_1 = require("rxjs");
const GameEvent_1 = require("../messaging/event/GameEvent");
const EventSourced_1 = require("../messaging/EventSourced");
const util_1 = require("../util");
const GameMode_1 = require("./states/GameMode");
const GameState_1 = require("./states/GameState");
const GameStateAction_1 = require("./states/GameStateAction");
const GameStateReducer_1 = require("./states/GameStateReducer");
const Table_1 = require("./Table");
class Game extends EventSourced_1.Evented {
    constructor(name, subscriber, id = nanoid_1.nanoid()) {
        super(id);
        this.name = name;
        this.tables = [];
        this.state = GameState_1.GameStates.PreGame;
        this.event$ = new rxjs_1.Subject();
        const table = new Table_1.Table(`${this.name}`);
        table.gameId = this.getId();
        table.gameName = this.name;
        this.tables = [table];
        if (subscriber) {
            this.event$.subscribe(subscriber);
        }
        this.update(GameEvent_1.GameEvents.created(this));
    }
    get defaultTable() {
        return this.tables[0];
    }
    startGame(option) {
        util_1.logger.trace(`startGame`, option);
        if (option) {
            const { mode, blindTimerCountdown } = option;
            this.tables.map((table) => {
                table.mode = GameMode_1.GameModes.returnMode(mode);
                if (GameMode_1.GameModes.isTournament(table.mode)) {
                    table.blindTimerCountdown = blindTimerCountdown;
                    if (table.gameStartTime === 0) {
                        table.gameStartTime = super.currentCheckpoint();
                        table.blindTimerCheckpoint =
                            table.gameStartTime + blindTimerCountdown * 60000;
                    }
                }
                else {
                    if (table.gameStartTime === 0) {
                        table.gameStartTime = super.currentCheckpoint();
                    }
                }
                if (table.isPaused()) {
                    table.unpause();
                }
                if (!table.isPlaying()) {
                    table.newHand();
                }
            });
        }
        else {
            this.tables.map((table) => {
                if (table.isPaused()) {
                    table.unpause();
                }
                if (!table.isPlaying()) {
                    table.newHand();
                }
            });
        }
        this.update(GameEvent_1.GameEvents.started(this));
    }
    resumeGame() {
        this.tables.map((table) => {
            if (table.isPaused()) {
                table.unpause();
                if (GameMode_1.GameModes.isTournament(table.mode)) {
                    table.blindTimerCheckpoint =
                        super.currentCheckpoint() +
                            (super.currentCheckpoint() - table.gamePauseTime);
                }
            }
        });
        this.update(GameEvent_1.GameEvents.started(this));
    }
    pauseGame() {
        this.tables.map((table) => {
            if (!table.isPaused()) {
                table.pause();
                if (GameMode_1.GameModes.isTournament(table.mode)) {
                    table.gamePauseTime = super.currentCheckpoint();
                }
            }
        });
        this.update(GameEvent_1.GameEvents.paused(this));
    }
    endGame() {
        this.update(GameEvent_1.GameEvents.ended(this));
    }
    onPokerGameCreated(event) {
        util_1.logger.trace('OnCreated called');
        this.setId(event.snapshot.gameId);
        this.name = event.snapshot.gameName;
        this.tables[0].setId(event.snapshot.table[0].id);
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.CreateGame, this.state);
    }
    onPokerGameStart() {
        util_1.logger.trace('OnStart called');
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.StartPlay, this.state);
    }
    onPokerGamePause() {
        util_1.logger.trace('OnPause called');
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.PausePlay, this.state);
    }
    getTablesForPlayer(userId) {
        return this.tables.filter((table) => table.getPlayerByUserId(userId) !== undefined);
    }
    onPokerGameEnd() {
        util_1.logger.trace('OnEnd called');
        this.state = GameStateReducer_1.GameReducer(GameStateAction_1.GameActions.EndGame, this.state);
    }
    update(event) {
        this.updateState(event);
        this.event$.next(event);
    }
    getId() {
        return super.getId();
    }
    getVersion() {
        return super.getVersion();
    }
    getEvents() {
        return super.getEvents();
    }
    internalState() {
        return this.state.tag;
    }
}
__decorate([
    class_transformer_1.Type(() => Table_1.Table),
    __metadata("design:type", Array)
], Game.prototype, "tables", void 0);
__decorate([
    class_transformer_1.Type(() => GameState_1.GameStates),
    __metadata("design:type", Object)
], Game.prototype, "state", void 0);
__decorate([
    class_transformer_1.Type(() => rxjs_1.Subject),
    __metadata("design:type", Object)
], Game.prototype, "event$", void 0);
__decorate([
    class_transformer_1.Type(() => Table_1.Table),
    __metadata("design:type", Table_1.Table),
    __metadata("design:paramtypes", [])
], Game.prototype, "defaultTable", null);
exports.Game = Game;
//# sourceMappingURL=Game.js.map